cafm.rb.scheduler = {

    instance: null,
    model: {
        id: 'RoomBookingId'
    },
    occurrences: [],
    roomDataSource: null,
    rooms: [],
    pageSize: 0,
    setupScheduler: function (defaultCriteria, locality, isPublic) {
        /// <summary>Setup room booking scheduler</summary>
        /// <param name="defaultCriteria" type="Object">The default criteria object</param>
        /// <param name="viewModel" type="Object">The view model object</param>
        /// <param name="isPublic" type="Boolean">Is the public calendar</param>

        var isPublicUser = cafm.auth.isPublic();

        // set public display if the user is public or an anon win guest user
        // TODO: consider refactor after 9.2.2 to not render the right column HTML at all
        if (cafm.nav.isNav(cafm.enums.Navigatable.RoomBookingPublicCalendar) && (isPublicUser || cafm.auth.isGuest())) body.addClass('public');

        defaultCriteria.Page = 1;

        // populate default criteria with locality
        $.extend(defaultCriteria, locality);

        // set default criteria
        this.setDefaultCriteria(defaultCriteria);

        // set page size
        this.pageSize = cafm.getClientSettings().roomBookingSettings.calendarPageSize;

        // if there is a forced locality on the client (e.g. view booking on calendar)
        if (cafm.rb.scheduler.roomLocality) {

            locality = cafm.rb.scheduler.roomLocality;
        }

        var criteria;
        if (isPublic) {

            defaultCriteria.IsPublic = true;

            if (!cafm.util.guidHasValue(defaultCriteria.RoomID)) {
                criteria = cafm.cache.get(cafm.res.consts.CacheKey_PublicCalendarCriteria);
            }
            else {
                cafm.cache.set(cafm.res.consts.CacheKey_PublicCalendarCriteria, defaultCriteria);
            }
        }

        if (!criteria) {

            criteria = cafm.util.clone(defaultCriteria);
            $.extend(criteria, locality);
        }

        // bind the criteria        
        this.setRoomCriteria(criteria);

        // get bound criteria
        var boundCriteria = this.getRoomCriteria();

        // setup the hierarchy filter control
        cafm.rb.scheduler.helpers.setupLocalityFilter(boundCriteria);
        
        if (!isPublic || cafm.rb.scheduler.hasSearchablePublicCriteria(boundCriteria)) {

            // now get the scheduler rooms
            this.getSchedulerRooms(function (rooms) {

                // expect list of rooms as the response
                cafm.rb.scheduler.rooms = rooms;

                // call this once we have our rooms to group the scheduler by
                cafm.handlers.exe(cafm.res.consts.HandlerName_BuildRoomBookingScheduler);
            });
        }
        else {
            
            var showPubMsg = isPublicUser || cafm.auth.isGuest();
            $('#schedulerMsgPnl').showMessage({ title: showPubMsg ? ($('.all-rooms-link').length ? cafm.res.str.MessagePublicCalendarSelectRoom : cafm.res.str.MessagePublicCalendarNotConfigured) : cafm.res.str.MessagePublicCalendarSelectFilters, type: showPubMsg ? cafm.enums.MessageType.Warnging : cafm.enums.MessageType.Info });
        } 

        // setup enter pressed event on the search text
        this.roomFilterContainer().find('.cfTextInput, .k-formatted-value').enterPressed(function (args) {
           
            $(args.currentTarget).blur();
            cafm.rb.scheduler.handlers.search();
        });

        $('.dash-full').click(function () {
            cafm.scheduler.helpers.viewFullScreen({
                scheduler: cafm.rb.scheduler.instance
            });
        });
        
        // CAFM-5381 fix for issue where the responsive view picker doesn't allow selection of week/day view
        $('#mainContentPane').off('click.cafmScheduler').on('click.cafmScheduler', '.k-current-view', function (e) {
            e.preventDefault();
        });
    },
    setupFilterEvents: function () {
        /// <summary>Setup room filter events</summary>

        var criteria = cafm.rb.scheduler.getRoomCriteria();
        var layDrop = cafm.rb.scheduler.roomFilterContainer().find('[name="RoomLayoutCodeID"]');

        // enable/disable the search button
        cafm.rb.scheduler.enableSearchButton(criteria);

        if (layDrop.length) {

            criteria.bind('change', function (args) {

                if(['RoomID', 'RoomLayoutCodeID'].indexOf(args.field) > -1) {

                    cafm.rb.scheduler.enableSearchButton(criteria);
                }

                if (args.field != 'LocationID') {

                    return;
                }

                var source = args.sender.source ? args.sender.source : args.sender;
                var lid = source.LocationID;
                if (!cafm.util.guidHasValue(lid)) {

                    lid = source.CompanyID;
                }

                var items = layDrop.data('items');
                var kLayDrop = cafm.rb.scheduler.roomFilterContainer().find('[name="RoomLayoutCodeID"]').data('kendoDropDownList');
                var filtered = cafm.util.filterItemsByLocationId(items, lid);
                kLayDrop.setDataSource(new kendo.data.DataSource({
                    data: filtered
                }));

                if (cafm.util.guidHasValue(criteria.RoomLayoutCodeID)) {

                    var exists = cafm.util.exists(filtered, function (layout) { return layout.value == criteria.RoomLayoutCodeID; });

                    if (!exists) {

                        criteria.set('RoomLayoutCodeID', cafm.guid.empty);
                    }
                    else {

                        kLayDrop.value(criteria.RoomLayoutCodeID);
                        kLayDrop.trigger('change');
                    }
                }
            });
        }
    },
    enableSearchButton: function(criteria) {

        $('[data-key="Search"]').prop('disabled', (criteria.IsPublic && !cafm.rb.scheduler.hasSearchablePublicCriteria(criteria)));
    },
    roomFilterContainer: function () {
        /// <summary>Get the room filter container element</summary>
        /// <returns type="jQuery">The room filter container element</param>

        return $('#calendarRoomFilters');
    },
    getRoomCriteria: function () {
        /// <summary>Get the room search criteria</summary>
        /// <returns type="Object">The room criteria object</param>

        return cafm.rb.scheduler.roomFilterContainer().getViewModel();
    },
    setRoomCriteria: function (viewModel) {
        /// <summary>Set the room search criteria</summary>
        /// <param name="viewModel" type="Object">The criteria object</param>

        if (cafm.rb.scheduler.roomLocality) {

            viewModel.LocalityID = cafm.rb.scheduler.roomLocality.LocationID;
        }

        if (cafm.rb.scheduler.roomFilterContainer().data('viewmodel')) {

            cafm.rb.scheduler.roomFilterContainer().setViewModel(viewModel);
        }
        else {

            cafm.rb.scheduler.roomFilterContainer().bindViewModel(viewModel);
        }
    },
    getDefaultCriteria: function () {
        /// <summary>Get the default room search criteria</summary>
        /// <returns type="Object">The criteria object</returns>

        return cafm.rb.scheduler.roomFilterContainer().data('defaultCriteria');
    },
    setDefaultCriteria: function (criteria) {
        /// <summary>Set the default room search criteria</summary>
        /// <param name="criteria" type="Object">The criteria object</param>

        criteria = cafm.util.clone(criteria, true);
        
        criteria.Description = {
            Value: null,
            WrapInWildCards: null
        };

        return cafm.rb.scheduler.roomFilterContainer().data('defaultCriteria', criteria);
    },
    hasSearchablePublicCriteria: function (criteria) {

        return cafm.util.guidHasValue(criteria.RoomID) || cafm.util.guidHasValue(criteria.RoomLayoutCodeID);
    },
    getSchedulerRooms: function (onDataRetrieved) {
        /// <summary>Get scheduler rooms from server</summary>
        /// <param name="onDataRetrieved" type="Function">Handler for the rooms returned</param>

        var rbs = cafm.rb.scheduler,
            criteria = rbs.getRoomCriteria();

        var hasFacility = function(value){

            var exists = cafm.util.exists(criteria.Facilities, function (f) { return (f.value || f) == value });
            return exists ? cafm.enums.DefaultableBooleanData.True : cafm.enums.DefaultableBooleanData.Either;
        }

        var dto = {
            CapacityFrom: criteria.CapacityFrom,
            Description: criteria.Description,
            HasProjector: hasFacility(cafm.res.consts.FieldName_HasFixedProjector),
            HasVideoConferencing: hasFacility(cafm.res.consts.FieldName_HasVideoConferencing),
            HasWhiteBoard: hasFacility(cafm.res.consts.FieldName_HasWhiteboard),
            IsViewableOnIntranet: true
        }

        if (rbs.roomLocality) {

            dto.LocalityID = rbs.roomLocality.LocationID;
        }
        else if(criteria.Locality) {

            dto.LocalityID = criteria.Locality.LocationID;
        }
        else {

            dto.LocalityID = criteria.LocalityID;
        }

        if (!cafm.util.guidHasValue(dto.LocalityID)) {

            dto.LocalityID = cafm.auth.companyId();
        }

        if (criteria.RoomLayoutCodeID) {

            dto.RoomLayoutCodeID = cafm.util.getItemValue(criteria.RoomLayoutCodeID);
        }

        // get the data by executing the action
        cafm.actions.execute({
            url: cafm.url.api('Room/GetBookableList'),
            values: dto,
            loaderSelector: '#main',
            statusCodeFuncs: {
                200: function (response) {

                    if (cafm.util.hasItem(response)){

                        // check room names for any starting with <
                        for(var i in response) {

                            var room = response[i];

                            // if room name starts with < then remove, as this causes kendo to not render the name
                            if (room.Description && room.Description.indexOf('<') == 0) {

                                room.Description = room.Description.substr(1);
                            }
                        }

                        if (rbs.roomLocality) {

                            response = cafm.util.where(response, function (room) {

                                return room.ID == rbs.roomLocality.RoomID;
                            });

                            delete rbs.roomLocality;
                        }
                    }

                    if (isFunc(onDataRetrieved)) {

                        onDataRetrieved(response);
                    }

                    rbs.helpers.showRoomPager(response);
                }
            }
        });
    },
    formatRoomData: function (rooms) {
        /// <summary>Formats room objects ready for binding to scheduler</summary>
        /// <param name="rooms" type="Array">Array of rooms</param>

        var crbs = cafm.rb.scheduler;

        // page the data
        if (rooms && crbs.pageSize > 0 && rooms.length > crbs.pageSize) {

            var criteria = crbs.getRoomCriteria(),
                page = criteria.Page && criteria.Page > 0 ? criteria.Page : 1,
                start = page <= 1 ? 0 : (page - 1) * crbs.pageSize,
                end = (page * crbs.pageSize);

            rooms = rooms.slice(start, end);
        }

        return cafm.util.transformArray(rooms, function (room) {
            
            return {

                text: room.Description,
                value: room.ID
            };
        })
    },
    formatRoomGroups: function () {
        /// <summary>Format room groups and apply non-working time to timeslots per room</summary>

        var scheduler = cafm.rb.scheduler.instance, groupTops = [];

        scheduler.getGroupElements().each(function (i, th) {

            th = $(th);
            if (th.attr('rowspan') > 1) {

                groupTops.push(th);

                var room = cafm.util.find(cafm.rb.scheduler.rooms, function (room) {

                    return room.Description == th.text();
                });

                if (room) {

                    th.attr('data-roomid', room.ID);
                    th.attr('title', room.Description);

                    if (cafm.util.guidHasValue(room.DefaultPhotoID)) {

                        // remove existing thumbnail links if any
                        th.find('.image-link,[data-replaceid]').remove();

                        // create thumbnail
                        var thumbPlc = th.setupImageThumbWithPopupWindow({
                            title: room.Description,
                            linkTitle: cafm.res.str.LabelViewRoom,
                            alt: room.Description,
                            thumbUrl: cafm.url.api('Room/GetDefaultImage/{0}?width=128', room.ID),
                            imageUrl: function () {

                                return cafm.url.api('Room/GetDefaultImage/{0}', room.ID);
                            }
                        });

                        // add it to the table cell
                        th.append(thumbPlc);
                    }

                    if (room.HasFixedProjector) {

                        th.append($('<div/>', {

                            'class': 'facIcon hasFp',
                            title: cafm.res.str.LabelHasFixedProjector
                        }))
                        th.append($('<div/>', {

                            'class': 'schedulerFpText',
                            text: '[FP]'
                        }))
                    }

                    if (room.HasVideoConferencingFacilities) {

                        th.append($('<div/>', {

                            'class': 'facIcon hasVc',
                            title: cafm.res.str.LabelHasVideoConferencing
                        }))
                        th.append($('<div/>', {

                            'class': 'schedulerVcText',
                            text: '[VC]'
                        }))
                    }

                    if (room.HasWhiteboard) {

                        th.append($('<div/>', {

                            'class': 'facIcon hasWb',
                            title: cafm.res.str.LabelHasWhiteboard
                        }))
                        th.append($('<div/>', {

                            'class': 'schedulerWbText',
                            text: '[WB]'
                        }))
                    }

                    if (!room.IsBookableOnIntranet) {

                        th.addClass('nonBookable');
                    }
                }
            }
        });

        // now apply group seperator styles separately for clarity
        for (var i = 0; i < groupTops.length; i++) {

            // the group header cell
            var th = groupTops[i];

            // get the time cell
            var timeCell = th.parent().prev().find('th:first');

            // add separator class
            timeCell.addClass('groupSepa');

            // get the adjacent timeslot cell
            var timeslotCell = scheduler.getTimeSlotElementsForTimeCell(timeCell);

            // add separator class
            timeslotCell.addClass('groupSepa');

            // if not last one then add group separator to the group header cell
            if (i != (groupTops.length - 1)) {

                // add separator class
                th.addClass('groupSepa');
            }

            // get all the timecells
            var timeCells = scheduler.getAllTimeCellsForRoom(th);

            if (timeCells.length) {

                // loop each timecell and then set any non-working time
                timeCells.forEach(function (tc) {

                    var tsc = scheduler.getTimeSlotElementsForTimeCell(tc);

                    if (tsc && tsc.length) {

                        var roomGroupId = th.data('roomid');
                        var room = cafm.util.find(cafm.rb.scheduler.rooms, function (room) {

                            return room.ID == roomGroupId;
                        });

                        cafm.rb.scheduler.helpers.checkTimeslotsAreBookable(tc, tsc, room);
                    }
                });
            }
        }
    },
    getRoomDataSource: function () {
        /// <summary>Get the scheduler room data source</summary>

        var crs = cafm.rb.scheduler,
            rds = crs.roomDataSource;

        if(rds){

            rds.data(crs.formatRoomData(crs.rooms));

            return rds;
        }
        else {

            crs.roomDataSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (options) {

                        var isPaged = options.data.page && crs.pageSize && crs.rooms && crs.pageSize < crs.rooms.length,
                            requiresRefresh;

                        if (isPaged) {

                            var page = options.data.page,
                                criteria = crs.getRoomCriteria();

                            if (page != criteria.Page) {

                                criteria.set('Page', page);
                                requiresRefresh = true;
                            }
                        }

                        // fire success handler
                        options.success(crs.formatRoomData(crs.rooms));

                        if (requiresRefresh) {
                            crs.refreshScheduler();
                        }
                    },
                    parameterMap: function (options, operation) {
                        if (operation !== "read" && options.models) {
                            return { models: kendo.stringify(options.models) };
                        }
                    }
                },
                schema: {

                    total: function (r) {
                        
                        return isArray(crs.rooms) ? crs.rooms.length : 0;
                    }
                },
                pageSize: crs.pageSize,
                serverPaging: true
            });

            return crs.roomDataSource;
        }
    },
    refreshRooms: function () {

        var rbs = cafm.rb.scheduler,
            criteria = cafm.rb.scheduler.getRoomCriteria(),
            hasSearchableCriteria = cafm.rb.scheduler.hasSearchablePublicCriteria(criteria);
        
        if (!criteria.IsPublic || hasSearchableCriteria) {

            rbs.getSchedulerRooms(function (rooms) {

                // expect list of rooms as the response
                rbs.rooms = rooms;
                
                // check for room datasource
                if (!rbs.roomDataSource) {
                    // call this as setup was delayed
                    cafm.handlers.exe(cafm.res.consts.HandlerName_BuildRoomBookingScheduler);
                }

                if (rbs.pageSize > 0 && rooms && rooms.length > rbs.pageSize) {

                    criteria.set('Page', 1);
                    rbs.roomDataSource.page(1);
                }
                else {

                    rbs.roomDataSource.read();
                }

                if (criteria.IsPublic) {

                    cafm.cache.set(cafm.res.consts.CacheKey_PublicCalendarCriteria, criteria);
                }

                rbs.refreshScheduler();
            });
        }
        else if (!hasSearchableCriteria) {
            
            $('#schedulerMsgPnl').showMessage({ title: cafm.res.str.MessagePublicCalendarSelectFilters, type: cafm.enums.MessageType.Info });
            
            if (rbs.instance) {
                cafm.scheduler.helpers.hideScheduler({

                    scheduler: rbs.instance,
                    showMessage: false
                });

                clearTimeout(cafm.ds.schedulerDataSourceTimeout);
            }
        }
    },
    refreshScheduler: function () {
        /// <summary>Refresh the scheduler rooms and data source</summary>

        var s = cafm.rb.scheduler.instance;
        var hasRoom = cafm.util.hasItem(cafm.rb.scheduler.rooms);

        if (!hasRoom) {

            cafm.scheduler.helpers.hideScheduler({

                scheduler: s,
                showMessage: true
            });
        }
        else {
            
            cafm.scheduler.helpers.showScheduler({

                scheduler: s,
                hideMessage: true
            });
            s.view(s.view().name);
        }

    },
    refreshSchedulerDataSource: function () {
        /// <summary>Refresh the scheduler data source</summary>

        cafm.rb.scheduler.instance.dataSource.read();
    },
    handlers: {

        openExistingBooking: function (args) {
            /// <summary>Open existing booking handler - triggered when an editable event is clicked</summary>
            /// <param name="args" type="Object">The event args</param>
            
            // check for the open booking lock 
            //if (cafm.rb.scheduler.openBookingLock) return;

            if (cafm.rb.scheduler.openBookingFlag) return;                     

            var cell = $(args.currentTarget);
            if (!cell.hasClass('.k-event')) {

                cell = cell.closest('.k-event');
            }

            if (!cafm.rb.scheduler.helpers.canOpenBookingForEdit(cell)) {

                return;
            }

            var scheduler = cafm.rb.scheduler.instance,
                uid = cell.data('uid'),
                booking = scheduler.occurrenceByUid(uid),
                vm = cafm.util.clone(booking);

            vm.StartTime = vm.StartDate;
            vm.EndTime = vm.EndDate;
            vm.BookingDateTime = cafm.rb.form.helpers.getBookingDateTimeText(vm.StartDate,vm.EndDate);
            vm.Description = vm.BookingDescription;            

            var dto = {
                RoomID: vm.RoomID,
                StartDate: cafm.web.funcs.fromSessionToUTCDateTime(vm.StartDate),
                EndDate: cafm.web.funcs.fromSessionToUTCDateTime(vm.EndDate)               
            }
             //set the openBooking flag
            cafm.rb.scheduler.openBookingFlag = true;

            cafm.actions.execute({
                url: cafm.url.api('RoomBooking/GetRoomBookingOccurrences'),
                values: dto,               
                success: function (occurrences) {
                    
                    var currentOccurrence = occurrences.filter(x => x.ScheduleOccurrenceId == vm.ScheduleOccurrenceId)[0];

                    if (currentOccurrence === undefined) {
                        cafm.util.OKDialogue({
                            message: cafm.res.str.MessageAutomaticallyReleasedBookingRefreshCalendar,
                            OKHandler: function () {
                                cafm.rb.scheduler.refreshSchedulerDataSource();
                                // clear existing selection
                                scheduler.select(null);
                            }
                        });
                    }
                    else {
                        // open existing booking view
                        cafm.views.openActionWindow({
                            url: cafm.url.get('RoomBooking/EditBookingFormBasic/{0}', vm.RoomBookingId),
                            method: 'GET',
                            isForm: true,
                            viewModel: vm,
                            initialText: cafm.res.str.TextPreparingForm,
                            winOptions: {
                                title: vm.Description,
                                width: 780,
                                height: 300
                            },
                            onLoad: function (pnl) {

                                vm = cafm.views.getActionWindowViewModel();

                                // if there's no VM then assume the window was closed before load event
                                if (!vm) return;

                                // set cost code restrictions, if applicable
                                let settings = cafm.rb.settings;
                                if (settings.costCodeExactLength || settings.costCodeMinLength || settings.costCodeMaxLength)
                                    cafm.rb.form.helpers.applyCostCodeRestriction();

                                // bind the set field handler function
                                vm.bind('set', cafm.rb.form.handlers.field.setField);

                                var c = isMobile ? cafm.views.getActionForm() : cafm.views.getActionForm().parents('.k-window:first');
                                var checkInOutButton = $('button[data-key="CheckInOutOccurrence"]', c);

                                if (checkInOutButton.length > 0) {
                                    cafm.rb.scheduler.helpers.showHideCheckInOutButton(checkInOutButton);
                                }

                            },
                            onWindowClose: function () {

                                // clear existing selection
                                scheduler.select(null);
                                //rest the openBooking flag
                                cafm.rb.scheduler.openBookingFlag = false;
                            }
                        });
                    }
                    
                },
                error: function () {
                    console.log("Error loading existing booking");
                     //rest the openBooking flag
                    cafm.rb.scheduler.openBookingFlag = false;
                }
            });

            return false;
        },
        openNewBooking: function () {
            /// <summary>Open new booking handler - triggered when a valid timeslot is clicked</summary>
            
            var slotElements = $('#bookingScheduler .k-scheduler-content .k-scheduler-table td.k-state-selected');
            if (!slotElements.length) return;

            // check room booking create permission
            var rbs = cafm.getClientSettings().roomBookingSettings;
            if (!rbs.canCreateBookings) return;

            var scheduler = cafm.rb.scheduler.instance,
            start, end, roomId, isNonWorkingTime;

            slotElements.each(function (i, slotElement) {

                if ($(slotElement).hasClass('k-nonwork-hour')) {

                    isNonWorkingTime = true;
                    return false;
                }

                var slot = scheduler.slotByElement(slotElement);

                if (!roomId) {

                    roomId = scheduler.resourcesBySlot(slot).RoomID;
                }

                if (!start || start > slot.startDate) {

                    start = slot.startDate;
                }

                if (!end || end < slot.endDate) {

                    end = slot.endDate;
                }
            });

            if (isNonWorkingTime) return;

            // selection is across multiple days - get lost!
            if (start.getDate() != end.getDate())  return;

            if (slotElements.length === 1) {

                end = cafm.util.addMinutes(start, rbs.defaultBookingDuration);
            }

            // check is valid booking date
            var args = {

                rbs: rbs,
                startDate: start,
                start: start,
                end: end,
                showMessage: true
            };
            if (!cafm.rb.helpers.isValidBookingDate(args).valid)  return;
            
            // now check for conflicts
            var conflictRes = cafm.rb.scheduler.helpers.checkForConflict({

                roomId: roomId,
                start: start,
                end: end,
                suggestAltTime: true
            });

            // if there is a conflict and new suggested start/end
            if (conflictRes.conflicts && conflictRes.suggestedStart != null) {

                // set start/end to suggestions
                start = conflictRes.suggestedStart;
                end = conflictRes.suggestedEnd;

                // set to false to allow code through next step
                conflictRes.conflicts = false;

                // check for valid booking date again as start/end changed
                args = {

                    startDate: start,
                    start: start,
                    end: end
                };
                if (!cafm.rb.helpers.isValidBookingDate(args).valid) return;
            }


            // if there is no conflict or it has been resolved through a suggestion
            if (conflictRes.conflicts === false) {

                // ensure room is bookable - shouldn't get here but just to be sure
                var room = cafm.util.find(cafm.rb.scheduler.rooms, function (r) {

                    return r.ID == roomId;
                });
                if (!room.IsBookableOnIntranet)  return;
                                
                var res = cafm.rb.scheduler.helpers.getRoomStartEndForDate(room, start),
                    maxEnd = new Date(rbs.calendarWindowEnd);

                // determine max end to be the room bookable end or the calendar end
                if (cafm.util.compareTimeStrings('{0}:{1}'.format(maxEnd.getHours(), maxEnd.getMinutes()), res.roomEnd) > 0) {

                    var pieces = res.roomEnd.split(':');
                    maxEnd.setHours(pieces[0]);
                    maxEnd.setMinutes(pieces[1]);
                }

                // trim end time if it exceeds calendar window end or bookable room end
                if (end.getHours() > maxEnd.getHours() || (end.getHours() == maxEnd.getHours() && end.getMinutes() > maxEnd.getMinutes())) {

                    end.setDate(start.getDate());
                    end.setHours(maxEnd.getHours());
                    end.setMinutes(maxEnd.getMinutes());
                }

                // check if the start exceeds the end - this can happen when there are suggestions and a trimmed end time
                if (start >= end)  return;

                // open new booking view
                cafm.views.openActionWindow({
                    url: cafm.url.get('RoomBooking/BookingFormBasic/{0}', roomId),
                    method: 'GET',
                    isForm: true,
                    viewModel: {
                        RoomId: roomId,
                        RoomDescription: room.Description,
                        StartDate: start,
                        StartTime: start,
                        EndTime: end,
                        ContactID: cafm.auth.personId(),
                        Contact: cafm.auth.isAnonGuest() ? '' : cafm.auth.personName(),
                        ContactEmail: cafm.auth.isAnonGuest() ? '' : cafm.auth.personEmail()
                    },
                    initialText: cafm.res.str.TextPreparingForm,
                    winOptions: {
                        title: cafm.res.str.TitleBookRoom,
                        width: 780,
                        height: 300
                    },
                    onLoad: function (pnl) {
                            
                        var vm = cafm.views.getActionWindowViewModel();

                        // if there's no VM then assume the window was closed before load event
                        if (!vm) return;

                        if (cafm.util.guidHasValue(vm.ContactID)) {

                            pnl.find('#contactLookup').hide();
                        }
                            
                        if (cafm.util.hasStringVal(vm.ContactEmail)) {

                            $('#ContactEmail').parents('.cfField:first').hide();
                        }

                        pnl.find('#contactLookup').data('onLookupSelected', cafm.rb.form.handlers.misc.contactLookupSelected);

                        // set cost code restrictions, if applicable
                        let settings = cafm.rb.settings;
                        if (settings.costCodeExactLength || settings.costCodeMinLength || settings.costCodeMaxLength)
                            cafm.rb.form.helpers.applyCostCodeRestriction();

                        // bind the set field handler function
                        vm.bind('set', cafm.rb.form.handlers.field.setField);

                        if (conflictRes.suggestedStart || conflictRes.suggestedEnd) {
                            
                            pnl.showMessage({
                                Type: cafm.enums.MessageType.Info,
                                Title: cafm.res.str.MessageDifferentStartEndSuggested
                            })
                        }
                    },                    
                    onWindowClose: function () {

                        // clear existing selection
                        scheduler.select(null);
                    }
                });
            }
        },
        reset: function () {
            /// <summary>Reset room search handler</summary>

            var rbs = cafm.rb.scheduler;
            var defaultCriteria = rbs.getDefaultCriteria();
            var criteria = cafm.util.clone(defaultCriteria);

            // set the criteria again
            cafm.rb.scheduler.setRoomCriteria(criteria);

            // reset locality filter
            cafm.rb.scheduler.helpers.setupLocalityFilter(cafm.rb.scheduler.getRoomCriteria());
            
            // clear facilities selection
            var kms = $('#Facilities').getKendoMultiSelect();
            if (kms) {
                kms.value('');
                kms.trigger('change');
            }

            // refresh rooms sent on the calendar
            rbs.refreshRooms();

            // trigger change event
            cafm.rb.scheduler.getRoomCriteria().trigger('change')
        },
        schedulerBeforeDataSourceRead: function (args) {
            
            args.values.RoomIds = cafm.util.transformArray(cafm.rb.scheduler.roomDataSource.data(), function (room) {

                return room.value;
            });

            return cafm.util.hasItem(args.values.RoomIds);
        },
        schedulerPreBuildControl: function (schedulerOptions, element) {
            /// <summary>Scheduler pre build event handler - used to populate rooms ready for rendering</summary>
            /// <param name="schedulerOptions" type="Object">The scheduler options</param>
            /// <param name="element" type="jQuery">The scheduler element</param>

            var crbs = cafm.rb.scheduler, ds = crbs.getRoomDataSource(), criteria = crbs.getRoomCriteria();

            // reset the page - this is required as Kendo picks up the previous page when navigating back to the calendar - not required as the criteria isn't persisted
            ds.page(1);

            $.extend(schedulerOptions, {
                group: {
                    resources: ['Rooms'],
                    orientation: 'vertical'
                },
                resources: [
                    {
                        field: 'RoomID',
                        name: 'Rooms',
                        dataSource: ds,
                        title: 'Room'
                    }
                ]
            });

            schedulerOptions.group.orientation = 'vertical';

            if (criteria.IsPublic) {

                cafm.util.removeWhere(schedulerOptions.views, function (v) { return v.type == 'week' });
                schedulerOptions.views.editable = false;
            } else {

                schedulerOptions.views.forEach(function (view) {
                    if (view.type == "day") {
                        view.selected = false;
                    } else if (view.type == "week") {
                        view.selected = true;
                    }
                });

                // show the filters
                cafm.layout.toggleLeftColumn();
            }

            return true;
        },
        schedulerPostBuildControl: function (schedulerOptions, scheduler) {
            /// <summary>Scheduler post build event handler - used to hide scheduler if there are no rooms</summary>
            /// <param name="schedulerOptions" type="Object">The scheduler options</param>
            /// <param name="sender" type="kendo.ui.Scheduler">The scheduler</param>
            
            cafm.rb.scheduler.instance = scheduler;

            var hasRoom = cafm.util.hasItem(cafm.rb.scheduler.rooms);

            if (!hasRoom) {

                cafm.scheduler.helpers.hideScheduler({

                    scheduler: scheduler,
                    showMessage: true
                });
            }

            let isPublic = body.hasClass('public');
            if (isPublic && cafm.rb.scheduler.rooms.length == 1) {
                let roomTz = cafm.rb.scheduler.rooms[0].TimeZoneName;
                if (roomTz !== cafm.cache.session.get(cafm.res.consts.CacheKey_TimeZone))
                {
                    //Following two calls should be combined but currently they are not and I dont want to change them now!
                    cafm.cache.session.set(cafm.res.consts.CacheKey_TimeZone, roomTz);
                    cafm.timezone.saveSessionTimeZone(roomTz, false);
                    cafm.url.set(cafm.url.get()); //This is temp hack but needed to keep client and server in sycn!
                }
            }

            return hasRoom;
        },
        schedulerBeforeUpdate: function (args) {
            /// <summary>Scheduler before event update handler</summary>
            /// <param name="args" type="Object">Event args</param>

            var event = args.data.models[0];
            event.StartDate = cafm.web.funcs.fromSessionToUTCDateTime(event.start);
            event.EndDate = cafm.web.funcs.fromSessionToUTCDateTime(event.end);
            return event;
        },
        schedulerAfterUpdate: function (args) {
            /// <summary>Scheduler after event update handler</summary>
            /// <param name="args" type="Object">Event args</param>
               
            var res = args.response;
            var event = args.event;

            res.PreparationStartDate = cafm.web.funcs.fromUTCToSessionDateTime(res.PreparationStartDate);
            res.PreparationEndDate = cafm.web.funcs.fromUTCToSessionDateTime(res.PreparationEndDate);
            event.PreparationStartDate.setDate(res.PreparationStartDate.getDate());
            event.PreparationStartDate.setHours(res.PreparationStartDate.getHours(), res.PreparationStartDate.getMinutes());
            event.PreparationEndDate.setDate(res.PreparationEndDate.getDate());
            event.PreparationEndDate.setHours(res.PreparationEndDate.getHours(), res.PreparationEndDate.getMinutes());
        },
        schedulerDataRetrieved: function (occurrences, sender) {
            /// <summary>Scheduler data retrived handler</summary>
            /// <param name="occurrences" type="Array">Array of occurrences data</param>
            /// <param name="sender" type="kendo.ui.Scheduler">The scheduler</param>

            if (!sender.element) {

                return;
            }

            if (cafm.util.hasItem(cafm.rb.scheduler.rooms)) {

                sender.element.show();
            }

            var prepareOccurrence = function (occ) {

                occ.StartDate = cafm.web.funcs.fromUTCToSessionDateTime(occ.StartDate);
                occ.EndDate = cafm.web.funcs.fromUTCToSessionDateTime(occ.EndDate);

                occ.PreparationStartDate = cafm.web.funcs.fromUTCToSessionDateTime(occ.PreparationStartDate);
                occ.PreparationEndDate = cafm.web.funcs.fromUTCToSessionDateTime(occ.PreparationEndDate);

                occ.start = occ.StartDate;
                occ.end = occ.EndDate;
            }

            if (isArray(occurrences)) {

                occurrences.forEach(prepareOccurrence);
            }
            else if (isObj(occurrences) && occurrences.StartDate) {

                prepareOccurrence(occurrences);
            }
        },
        schedulerDataBound: function (args) {
            /// <summary>Scheduler data bound handler - once the scheduler is bound we attach events and format the timeslots with non-bookable time</summary>
            /// <param name="args" type="Object">Event args</param>

            var crbs = cafm.rb.scheduler,
                scheduler = args.sender,
                v = scheduler.view();

            crbs.instance = scheduler;

            if (['month', 'agenda'].indexOf(v.name) == -1) {

                var occurrences = [];
                var wds = v.options.workDayStart;
                var wde = v.options.workDayEnd;

                // existing bookings
                $('.k-scheduler-content .k-event[role="gridcell"]', v.element).each(function (i, el) {

                    var cell = $(el);
                    var uid = cell.data('uid');
                    var occ = scheduler.occurrenceByUid(uid);
                    occurrences.push(occ);

                    // if calendar activity then ignore
                    if(occ.IsCalendarActivity){

                        return true;
                    }

                    var duration, prep, durationMins, prepMins, prepProportion, h, limit;

                    if (!cafm.util.dateTimesAreSame(occ.PreparationStartDate, occ.start)) {

                        duration = cafm.util.datesHoursMinsDiff(occ.start, occ.end);
                        limit = new Date(occ.start.getFullYear(), occ.start.getMonth(), occ.start.getDate(), wds.getHours(), wds.getMinutes());

                        if (v.options.showWorkHours && occ.PreparationStartDate < limit) {

                            prep = cafm.util.datesHoursMinsDiff(limit, occ.start);
                        }
                        else {

                            prep = cafm.util.datesHoursMinsDiff(occ.PreparationStartDate, occ.start);
                        }

                        durationMins = duration.minutes + (duration.hours * 60);
                        prepMins = prep.minutes + (prep.hours * 60);
                        prepProportion = durationMins / prepMins;

                        h = Math.round(cell.height() / prepProportion);
                        var prepEl = $('<span />', {
                            height: h,
                            'class': 'prepEl',
                            css: { 'top': ((h + 1) * -1) + 'px' },
                            title: cafm.res.str.LabelUnavailable
                        });
                        cell.prepend(prepEl);
                        cell.addClass('hasPrep');
                    }

                    if (!cafm.util.dateTimesAreSame(occ.PreparationEndDate, occ.end)) {

                        duration = cafm.util.datesHoursMinsDiff(occ.start, occ.end);
                        limit = new Date(occ.end.getFullYear(), occ.end.getMonth(), occ.end.getDate(), wde.getHours(), wde.getMinutes());

                        if (v.options.showWorkHours && occ.PreparationEndDate > limit) {

                            prep = cafm.util.datesHoursMinsDiff(occ.end, limit);
                        }
                        else {

                            prep = cafm.util.datesHoursMinsDiff(occ.end, occ.PreparationEndDate);
                        }

                        durationMins = duration.minutes + (duration.hours * 60);
                        prepMins = prep.minutes + (prep.hours * 60);
                        prepProportion = durationMins / prepMins;

                        h = Math.round(cell.height() / prepProportion);
                        var cleanDownEl = $('<span />', {
                            height: h,
                            'class': 'cleanDownEl',
                            css: { 'bottom': ((h + 1) * -1) + 'px' },
                            title: cafm.res.str.LabelUnavailable
                        });
                        cell.append(cleanDownEl).addClass('hasClearDown');
                    }
                });

                crbs.occurrences = occurrences;

                if (cafm.nav.isNav(cafm.enums.Navigatable.RoomBookingCalendar)) {

                    if (isTouch) {

                        // handle timeslot click and touch
                        $('.k-scheduler-content .k-scheduler-table', v.element).off('click.cafm').on('click.cafm', 'td', crbs.handlers.openNewBooking);

                        // handle occurrence clicks
                        v.element.off('click.cafm').on('click.cafm', '.cOccurrence', function (event) {

                            $('.cOccurrenceOpen').remove();

                            var element = $(event.currentTarget);

                            if (cafm.rb.scheduler.helpers.canOpenBookingForEdit(element)) {

                                $('<a />', {

                                    'class': 'cOccurrenceOpen',
                                    text: cafm.res.str.LabelOpenBooking,
                                    click: crbs.handlers.openExistingBooking
                                }).prependTo(element);
                            }
                        });
                    }
                    else {

                        // handle timeslot clicks
                        $('.k-scheduler-content .k-scheduler-table', v.element).off('mouseup.cafm').on('mouseup.cafm', 'td', crbs.handlers.openNewBooking);

                        // handle occurrence clicks
                        v.element.off('click.cafm').on('click.cafm', '.k-event[role="gridcell"]', crbs.handlers.openExistingBooking);
                    }
                }

                // add facility icons to the scheduler
                crbs.formatRoomGroups();
            }
        },
        schedulerMoveEnd: function (args) {
            /// <summary>Scheduler event move end handler</summary>
            /// <param name="args" type="Object">Event args</param>

            cafm.rb.scheduler.helpers.ensureEndUpdateBookingEvent(args);
        },
        schedulerMoveStart: function (args) {
            /// <summary>Scheduler event move start handler</summary>
            /// <param name="args" type="Object">Event args</param>

            cafm.rb.scheduler.helpers.ensureStartUpdateBookingEvent(args);
        },
        schedulerResizeEnd: function (args) {
            /// <summary>Scheduler event resize end handler</summary>
            /// <param name="args" type="Object">Event args</param>

            cafm.rb.scheduler.helpers.ensureEndUpdateBookingEvent(args);
        },
        schedulerResizeStart: function (args) {
            /// <summary>Scheduler event resize start handler</summary>
            /// <param name="args" type="Object">Event args</param>

            cafm.rb.scheduler.helpers.ensureStartUpdateBookingEvent(args);
        },
        search: function () {
            /// <summary>Search handler</summary>

            var rbs = cafm.rb.scheduler;

            var criteria = cafm.rb.scheduler.getRoomCriteria();
            var locWid = cafm.rb.scheduler.roomFilterContainer().find('.localityWidget');
            var msg = locWid.find('.msgPnl');

            if (cafm.util.guidHasValue(criteria.LocationID)) {

                if (msg.length) {

                    msg.hide();
                }

                // refresh rooms sent on the calendar
                rbs.refreshRooms();
            }
            else {

                if (msg.length) {

                    msg.show();
                }
                else {

                    cafm.msg.appendMessagePanelTo({

                        element: locWid,
                        options: {
                            Title: cafm.res.str.MessageSelectLocation,
                            Type: cafm.enums.MessageType.Error
                        }
                    });
                }
            }
        },
        calendar: {

            allRooms: function () {

                cafm.url.set(cafm.auth.isPublic() ? cafm.res.consts.Url_RoomBookingRoomListAlias : '~/roombooking#allRooms');
            },
            fullScreen: function () {

                cafm.scheduler.helpers.viewFullScreen({
                    scheduler: cafm.rb.scheduler.instance
                });
            }
        }
    },
    helpers: { 
        
        canOpenBookingForEdit: function (element) {
            /// <summary>Checks if a booking can be opened for editing</summary>
            /// <param name="element" type="$">Booking element</param>

            if (!element.hasClass('.k-event')) {

                element = element.closest('.k-event');
            }

            var scheduler = cafm.rb.scheduler.instance;
            var uid = element.data('uid');
            var rb = scheduler.occurrenceByUid(uid);
            var rbs = cafm.getClientSettings().roomBookingSettings;

            if (rb.IsCalendarActivity || rb.IsBookingForDifferentRoom || !rbs.canEditBookings || (rb.ContactId != cafm.auth.personId() && !rbs.canEditOthersBookings)) {

                return false;
            }

            if (!rb.IsRecurringOccurrence && rb.EndDate <= cafm.web.funcs.getSessionDateTimeNow()) {

                cafm.msg.showMessageInWindow({

                    type: cafm.enums.MessageType.Info,
                    title: cafm.res.str.MessageCannotEditFinishedMeetings
                });
                return false;
            }

            return true;
        },
        checkForConflict: function (args) {
            /// <summary>Checks if a start / end conflicts with any confirmed bookings</summary>
            /// <param name="args" type="Object">The method args containing start, end, roomId</param>
            /// <returns type="Object">The result object containing 'conflicts' boolean and suggestedStart and suggestedEnd if applicable - or false if conflicts and there are no suggestions</returns>

            var checkTimes = function (occurrenceStart, occurrenceEnd, bookingStart, bookingEnd) {

                occurrenceStart = occurrenceStart.getTime();
                occurrenceEnd = occurrenceEnd.getTime();
                bookingStart = bookingStart.getTime();
                bookingEnd = bookingEnd.getTime();

                return  (occurrenceStart <= bookingStart && occurrenceEnd >= bookingEnd) || 
                        (!(bookingEnd <= occurrenceStart) && occurrenceStart >= bookingStart && occurrenceEnd >= bookingEnd) ||
                        (!(bookingStart >= occurrenceEnd) && occurrenceStart <= bookingStart && occurrenceEnd <= bookingEnd) || 
                        (occurrenceStart >= bookingStart && occurrenceEnd <= bookingEnd) || 
                        (occurrenceStart >= bookingStart && occurrenceEnd <= bookingEnd);
            }

            // get the room
            var room = cafm.util.find(cafm.rb.scheduler.rooms, function (r) {

                return r.ID == args.roomId;
            }), prepStart = args.start, prepEnd = args.end;

            if (room.SetUpTimeMinutes) {

                // subtract setup from start
                prepStart = cafm.util.subMinutes(args.start, room.SetUpTimeMinutes);
            }

            if (room.CleanDownTimeMinutes) {

                // add clean down to end
                prepEnd = cafm.util.addMinutes(args.end, room.CleanDownTimeMinutes)
            }
            
            // check for conflict func
            var checkConflict = function (o) {

                return (!args.event || args.event.RoomBookingId != o.RoomBookingId) &&
                    args.roomId == o.RoomID &&
                    !o.IsProvisional &&
                    checkTimes(o.StartDate, o.EndDate, prepStart, prepEnd);
            };

            if (args.suggestAltTime) {

                // check for a confirmed clash
                var conflicts = cafm.util.where(cafm.rb.scheduler.occurrences, checkConflict);

                // if there are conflicts
                if (cafm.util.hasItem(conflicts)) {

                    var sStart = args.start, sEnd = args.end;

                    // look the conflicts and modify start and end to not conflict
                    conflicts.forEach(function (conflict) {

                        // check start
                        if (sStart >= conflict.StartDate) {
                            
                            // apply setup if applicable
                            if(room.SetUpTimeMinutes) {

                                sStart = cafm.util.addMinutes(conflict.EndDate, room.SetUpTimeMinutes);
                            }
                            else {

                                sStart = conflict.EndDate;
                            }

                            // push the end based on the selected / defaulted duration
                            var duration = cafm.util.datesMinsDiff(args.start, args.end);
                            sEnd = cafm.util.addMinutes(sStart, duration);
                        }
                        
                        // check end
                        else if(sEnd >= conflict.StartDate) {

                            // apply clean down if applicable
                            if (room.CleanDownTimeMinutes) {

                                sEnd = cafm.util.subMinutes(conflict.StartDate, room.CleanDownTimeMinutes);
                            }
                            else {

                                sEnd = conflict.PreparationStartDate;
                            }
                        }
                    });

                    // nullify the dates if suggestion is not valid
                    if (sStart >= sEnd) {

                        return {

                            conflicts: true,
                            suggestedStart: null,
                            suggestedEnd: null
                        };
                    }
                    else {

                        args.start = sStart;
                        args.end = sEnd;
                        args.suggestedStart = sStart;
                        args.suggestedEnd = sEnd;

                        return cafm.rb.scheduler.helpers.checkForConflict(args);
                    }
                }
                else {

                    // return the suggestion
                    return {

                        conflicts: args.suggestedStart ? true : false,
                        suggestedStart: args.suggestedStart ? args.suggestedStart : null,
                        suggestedEnd: args.suggestedStart ? args.suggestedEnd : null,
                    };
                }
            }
            else {

                return {
                    // check for a confirmed clash
                    conflicts: cafm.util.exists(cafm.rb.scheduler.occurrences, checkConflict)
                }
            }
        },
        checkTimeslotsAreBookable: function (timeCell, timeSlotElements, room) {
            /// <summary>Checks timeslots are bookable for a given room - checks the rooms bookable week and checks for confirmed bookings</summary>
            /// <param name="timeCell" type="jQuery">The time cell</param>
            /// <param name="timeSlotElements" type="Object">The timeslot elements</param>
            /// <param name="room" type="Object">The room</param>

            if (room.IsBookableOnIntranet && room.CanBookRoom) {
                
                var timeString = timeCell.data('time');
                var isDayView = cafm.rb.scheduler.instance.view().name == 'day';

                var doWork = function (timeSlotElement) {

                    var timeSlot = cafm.rb.scheduler.instance.slotByElement(timeSlotElement),
                        res = cafm.rb.scheduler.helpers.getRoomStartEndForDate(room, timeSlot.startDate),
                        roomStart = res.roomStart,
                        roomEnd= res.roomEnd,
                        isBookableTime;

                    if (!timeSlot) return;                    

                    if (!isNullOrUndefined(roomStart)) {

                        var res = cafm.util.compareTimeStrings(timeString, roomStart);
                        isBookableTime = res != -1;

                        if (isBookableTime) {

                            res = cafm.util.compareTimeStrings(timeString, roomEnd);
                            isBookableTime = res == -1;
                        }
                    }
                    else {

                        isBookableTime = false;
                    }

                    if (!isBookableTime) {

                        timeSlotElement.addClass('k-nonwork-hour');
                    }
                }

                timeSlotElements.each(function (i, timeSlotElement) {

                    doWork($(timeSlotElement));
                });
            }
            else {

                timeSlotElements.addClass('k-nonwork-hour');
            }
        },
        createOpenBookingLock: function () {
            /// <summary>Create an open booking lock to prevent the booking from being opened when moving or resizing - the lock lasts 1 second</summary>

            cafm.rb.scheduler.openBookingLock = new Object();

            setTimeout(function () {

                delete cafm.rb.scheduler.openBookingLock;
            }, 1000);
        },
        ensureEndUpdateBookingEvent: function (args) {
            /// <summary>Ensure the update booking event - checks the room booking can be updated with it's destination booking time</summary>
            /// <param name="args" type="Object">The event arguments</param>

            // create an open booking lock so we don't open the booking while dragging / resizing
            cafm.rb.scheduler.helpers.createOpenBookingLock();

            // valid flag
            var valid = true;

            // check for past time slot
            if (args.slot.end <= cafm.web.funcs.getSessionDateTimeNow()) valid = false;

            // check for different room as we don't allow changing the room from the calendar
            if (valid && args.resources.RoomID != args.event.RoomID) valid = false;

            // if valid then check for conflicting bookings
            if (valid) {

                valid = !cafm.rb.scheduler.helpers.checkForConflict({

                    roomId: args.event.RoomID,
                    start: args.start,
                    end: args.end,
                    event: args.event
                }).conflicts;
            }

            // if there is one then prevent it
            if (!valid) {

                args.preventDefault();
            }
        },
        ensureStartUpdateBookingEvent: function (args) {
            /// <summary>Ensure the update booking event - checks the room booking can be updated at a high level</summary>
            /// <param name="args" type="Object">The event arguments</param>
            
            var valid = true;
            var rb = args.event;

            var room = cafm.util.find(cafm.rb.scheduler.rooms, function (r) {

                return r.ID == rb.RoomID;
            });

            // check room is bookable on web and also if it's a calendar activity
            if (!room.IsBookableOnIntranet || rb.IsCalendarActivity || rb.IsBookingForDifferentRoom || !rb.IsProvisional || cafm.nav.isNav(cafm.enums.Navigatable.RoomBookingPublicCalendar)) {

                valid = false;
            }
            // check for past booking, or recurring/ad-hoc bookings
            else if (rb.EndDate < cafm.web.funcs.getSessionDateTimeNow() || rb.IsRecurringOccurrence) {

                valid = false;
            }

            if (valid) {

                // check if user can edit others booking and if they are the contact
                var rbs = cafm.getClientSettings().roomBookingSettings;
                if (!rbs.canEditBookings || (!rbs.canEditOthersBookings && cafm.auth.personId() != rb.ContactId)) {

                    valid = false;
                }
            }

            // if not valid then prevent the update behaviour
            if (valid === false) {

                args.preventDefault();
            }
        },
        getRoomStartEndForDate: function (room, date) {
            /// <summary>Ensure the update booking event - checks the room booking can be updated with it's destination booking time</summary>
            /// <param name="room" type="Object">The room</param>
            /// <param name="date" type="Date">The date</param>
            /// <returns type="Object">The result object containing roomStart and roomEnd</returns>

            var res = {}, bw = room.BookableWeek;

            switch (date.getDay()) {

                case 0:

                    if (bw.DoesWorkSunday) {

                        res.roomStart = bw.SundayStartTimeAsTimeOfDay;
                        res.roomEnd = bw.SundayEndTimeAsTimeOfDay;
                    }
                    break;

                case 1:

                    if (bw.DoesWorkMonday) {

                        res.roomStart = bw.MondayStartTimeAsTimeOfDay;
                        res.roomEnd = bw.MondayEndTimeAsTimeOfDay;
                    }
                    break;

                case 2:

                    if (bw.DoesWorkTuesday) {

                        res.roomStart = bw.TuesdayStartTimeAsTimeOfDay;
                        res.roomEnd = bw.TuesdayEndTimeAsTimeOfDay;
                    }
                    break;

                case 3:

                    if (bw.DoesWorkWednesday) {

                        res.roomStart = bw.WednesdayStartTimeAsTimeOfDay;
                        res.roomEnd = bw.WednesdayEndTimeAsTimeOfDay;
                    }
                    break;

                case 4:

                    if (bw.DoesWorkThursday) {

                        res.roomStart = bw.ThursdayStartTimeAsTimeOfDay;
                        res.roomEnd = bw.ThursdayEndTimeAsTimeOfDay;
                    }
                    break;

                case 5:

                    if (bw.DoesWorkFriday) {

                        res.roomStart = bw.FridayStartTimeAsTimeOfDay;
                        res.roomEnd = bw.FridayEndTimeAsTimeOfDay;
                    }
                    break;

                case 6:

                    if (bw.DoesWorkSaturday) {

                        res.roomStart = bw.SaturdayStartTimeAsTimeOfDay;
                        res.roomEnd = bw.SaturdayEndTimeAsTimeOfDay;
                    }
                    break;
            }

            return res;
        },
        setupLocalityFilter: function (locality) {
            /// <summary>Setup the calendar locality filter</summary>
            /// <param name="locality" type="Object">The locality object</param>

            var locWidget = $('.sideWidget.localityWidget');
            cafm.hi.casc.setup(locWidget, locality);

            setTimeout(function () {
                
                cafm.hi.casc.setCascadingCombosVisibility(cafm.hi.hierarchy.childMappings.Company.name, locality, cafm.hi.casc.getAllowedLocalityDepth(), locWidget);
            }, 1)
        },
        showRoomPager: function (rooms) {
            /// <summary>Ensure the update booking event - checks the room booking can be updated with it's destination booking time</summary>
            /// <param name="rooms" type="Object">The room</param>

            var rbs = cafm.rb.scheduler,
                sgp = $('#schedulerGroupPager'),
                sgc = $('#schedulerGroupCount');

            // enable paging or just show the total
            if (rbs.pageSize && rooms && rooms.length > rbs.pageSize) {

                // show pager

                // hide the count label
                if (sgc.length) sgc.hide();

                // create pager if not done already
                if (!sgp.length) {

                    // create the pager container
                    sgp = $('<div/>', {

                        id: 'schedulerGroupPager',
                        'class': 'schedulerGroupPager'
                    }).appendTo($('#bookingScheduler'));
                                            
                    // create the pager
                    $('<ul/>', {
                        'class': 'cLvPager'
                    }).appendTo(sgp).kendoPager({
                        dataSource: rbs.roomDataSource,
                        previousNext: true,
                        buttonCount: 5,
                        messages: {
                            display: cafm.res.str.TemplateRoomPagerInfo
                        },
                        change: function () {
                            // clear scheduler selection
                            rbs.instance.select(null);
                        }
                    });
                }

                // show the pager
                sgp.show();
            }
            else {

                // hide the pager
                if (sgp.length) sgp.hide();

                var roomCount = rbs.rooms.length,
                    roomText = roomCount == 1 ? cafm.res.str.LabelRoom : cafm.res.str.LabelRooms;
                
                // add the count label if not already done
                if (!sgc.length) {

                    sgc = $('<span/>', {

                        id: 'schedulerGroupCount',
                        'class': 'schedulerGroupCount'
                    }).appendTo($('#bookingScheduler'));
                }

                // set count text
                sgc.text('{0} {1}'.format(roomCount, roomText));

                // show the count text
                sgc.show();
            }
        },
        showHideCheckInOutButton: function (checkInBtn){

            vm = cafm.views.getActionWindowViewModel();

            //default datetime value if datetime is null
            var minDate = "0001-01-01T00:00:00Z";

            // RB settings
            var rbs = cafm.getClientSettings().roomBookingSettings;

            if (rbs.enableCheckInCheckOut == true) {

                var currentDateTime = cafm.web.funcs.getSessionDateTimeNow();
                var startTime = new Date(vm.StartTime);

                startTime.setMinutes(startTime.getMinutes() - rbs.allowCheckInBeforeBookingBegins);
                var beforeStartTime = startTime;
                startTime = new Date(vm.StartTime);
                startTime.setMinutes(startTime.getMinutes() + rbs.allowCheckInAfterBookingBegins);
                var afterStartTime = startTime;

                if (vm.CheckInDate == minDate) {
                    if (!(currentDateTime >= beforeStartTime && currentDateTime <= afterStartTime)) {
                        checkInBtn.hide();
                    }
                    else {
                        checkInBtn.show();
                        checkInBtn.attr('style', 'background-color: #3276b1 !important; color:white !important');
                    }
                }
                else if (vm.CheckInDate !== minDate && vm.CheckOutDate === minDate) {
                    checkInBtn.html(cafm.res.str.CheckOutOccurrence);
                    checkInBtn.attr('style', 'background-color: #dc3545 !important; color:white !important');
                }
                else {
                    checkInBtn.remove();
                }

            }    
        }
    }
}